import store from '@/store';

/**
 * Check if user is logged out. If not, prevent routing.
 *
 * @param to
 * @param from
 * @param next
 * @return {*}
 */
export default (to, from, next) => {
	if (check()) {
		return next();
	}

	return next(from);
};

/**
 * Check if user is logged out.
 *
 * @return {boolean}
 */
export function check() {
	return !store.getters.getLoggedIn;
}
